// extracted by mini-css-extract-plugin
export var colFooter = "footer-module--colFooter--87bba";
export var colFooterImg = "footer-module--colFooterImg--f9580";
export var colImg = "footer-module--colImg--358ac";
export var container = "footer-module--container--a0b36";
export var containerImg = "footer-module--containerImg--4705c";
export var containerLogos = "footer-module--containerLogos--15a84";
export var containerLogosHelp = "footer-module--containerLogosHelp--0cd4a";
export var footerBar = "footer-module--footerBar--2e982";
export var footerBarDenarium = "footer-module--footerBarDenarium--98d4c";
export var jenny = "footer-module--jenny--85666";
export var logo = "footer-module--logo--7dfa9";
export var row = "footer-module--row--4a9ed";
export var textAlianzas = "footer-module--textAlianzas--4561a";
export var textFooter = "footer-module--textFooter--75ab1";
export var titleAlianzas = "footer-module--titleAlianzas--8512e";
export var titleFooter = "footer-module--titleFooter--4460d";